module.exports = __webpack_public_path__ + "svg/illustration-address.953be78.svg";